import { Map, List } from 'immutable';

import { TYPES } from './actions';
import Logger from '../../../lib/Logger';

export default function CognitoForms(
  state = Map({
    isLoading: false,
    pages: {},
    isFormVisible: false,
  }),
  action
) {
  Logger.log(
    'debug',
    `[state.CognitoForms.reducers] CognitoForms(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case TYPES.COGNITO_FORM_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.COGNITO_FORM_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['pages', action.order, action.limit, action.page],
          List(action.result)
        );

    case TYPES.COGNITO_FORM_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `CognitoForms.reducers loaded.`);
